import thunk from "redux-thunk";
import { createLogger } from "redux-logger";

const configureMiddleware = (
  initialState,
  platformDeps,
  platformMiddleware
) => {
  const middleware = [
    thunk.withExtraArgument({
      ...platformDeps
    }),
    ...platformMiddleware
  ];

  const enableLogger = process.env.NODE_ENV !== "production";

  // Logger must be the last middleware in chain.
  if (enableLogger) {
    const ignoredActions = [];
    const logger = createLogger({
      collapsed: true,
      predicate: (getState, action) =>
        ignoredActions.indexOf(action.type) === -1,
      // Convert immutable to JSON.
      stateTransformer: state => JSON.parse(JSON.stringify(state))
    });
    middleware.push(logger);
  }

  return middleware;
};

export default configureMiddleware;



// WEBPACK FOOTER //
// ./src/config/configureMiddleware.js